import React from 'react';

import { Row } from '../atoms/row';
import { LinkComponent } from '../atoms/link-component';

import { Inspect as InspectComp } from '../templates/inspect';

const InspectSpot = () => {
  return (
    <>
      <h1>Inspect Spot</h1>

      <Row gap={1}>
        <LinkComponent to="/inspect">Home</LinkComponent>
        <LinkComponent to="/inspect/inverter">Inverter</LinkComponent>
        <LinkComponent to="/inspect/wallbox">Wallbox</LinkComponent>
        <LinkComponent to="/inspect/heat-pump">Heat pump</LinkComponent>
        <LinkComponent to="/inspect/mqtt">MQTT</LinkComponent>
        <LinkComponent to="/inspect/plugs">Plugs</LinkComponent>
        <LinkComponent to="/inspect/spot">Spot</LinkComponent>
        <LinkComponent to="/inspect/plc">PLC</LinkComponent>
      </Row>

      <InspectComp
        variableIds={[
          'SP_TEST_MODE',
          'SP_TEST_MODE_PRICE_SET',
          'SP_FORECAST_PV',
          'SP_FORECAST_HOME_CONSUMPTIN',
          'SP_FORECAST_HOME_CONSUMPTIN_PV',
          'SP_PV_TOTAL_CONSUMPTION',
          'SP_FORECAST_HP_CONSUMPTIN',
          'SP_FORECAST_PV_DEBREEFING',
          'SP_FORECAST_BATTERY_CONSUMPTIN',
          'SP_HOURS_PRICE_DATE',
          'SP_ACTUAL_PRICE',
          'SP_PV_RADIATION_DATE',
          'SP_LOW_PRICE',
          'SP_HI_PRICE',
          'SP_PRICE_HYSTERESIS',
          'SP_BATTERY_CHARGE',
          'SP_BATTERY_DISCHARGE',
          'SP_PRICE_PERIOD',
          'SP_DISCHARGE_TO_GRID_FINAL_SOC',
          'SP_NIGHT_BATTERY_CONSUMPTION',

          //table
          'SP_BATTERY_GRID_CHARGE_TABLE_15M',
          'SP_BATTERY_GRID_DISCHARGE_TABLE_15M',
        ]}
      />
    </>
  );
};

export default InspectSpot;
